import React, {useEffect, useState} from "react";
import {useForm} from "react-hook-form";

import Select, {createFilter} from "react-select";
import {
    getBankingSettlementAccountInfoApi, getPrintTerminalDetailsByIDApi,
    getRegionsDetailsApi, getRegionsDetailsByIdApi,
    getTerminalCassettesInfoApi, getTerminalContactDetailsByIDApi,
    getTerminalDetailByIDForEditApi, getTerminalNotesByIDApi, getTerminalSettlementByIDApi, getTerminalSurchargeByIDApi
} from "../Api";
import CustomOption from "../Utils/CustomOption";
import CustomMenuList from "../Utils/CustomMenuList";
import {useHistory} from "react-router-dom";
import axios from "axios";
import ConsoleHelper from "../ConsoleHelper";
import consoleHelper from "../ConsoleHelper";


function TerminalCreatePage(props) {

    const history = useHistory();
    const options = [
        { label: "1", value: "1" },
        { label: "2", value: "2" },
        { label: "3", value: "3" },
        { label: "4", value: "4" },
        { label: "5", value: "5" },
        { label: "6", value: "6" },
    ];



    const defaultSelectOption = { label: "1", value: "1" };
    const defaultSelectStateOption = { label: "Select Region", value: "-1" };
    const loggedUserStorage = sessionStorage.getItem('loggedUserStorage');
    const [showTerminalDiv, setShowTerminalDiv] = useState();
    const [settlementOptions, setSettlementOptions] = useState([]);
    const [regionOptions, setRegionOptions] = useState();
    const [settlementValue, setSettlementValue] = useState();
    const [settlementValue1, setSettlementValue1] = useState();
    const [settlementValue2, setSettlementValue2] = useState();
    const [settlementValue3, setSettlementValue3] = useState();
    const [settlementValue4, setSettlementValue4] = useState();
    const [cassetteOptions, setCassetteOptions] = useState(defaultSelectOption);
    const [selectedCassetteValue, setSelectedCassetteValue] = useState(defaultSelectOption);
    const [selectedRegionValue, setRegionValue] = useState();
    const [terminalID, setTerminalID] = useState();
    const [paramInteracText, setParamInteracText] = useState();



    const {
        register,
        handleSubmit,
        reset,
        setValue, getValues,
        formState: { errors },
        clearErrors
    } = useForm();

    const printTerminalDetails = async (terminalId) => {
        const printWindow = window.open('', '_blank');

        printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
        <title>Terminal Details - ${terminalId}</title>
        <link rel="icon" type="image/jpeg" href="https://passporttechnology.com/wp-content/uploads/2023/09/favicon.jpg" />
        <link rel="shortcut icon" type="image/jpeg" href="https://passporttechnology.com/wp-content/uploads/2023/09/favicon.jpg" />
        <style>
            body { 
                font-family: 'Courier New', monospace; 
                padding: 20px; 
                font-size: 12px;
                line-height: 1.4;
            }
            .header {
                text-align: center;
                margin-bottom: 20px;
                border-bottom: 2px solid #000;
                padding-bottom: 10px;
            }
            .main-container {
                display: flex;
                gap: 20px;
            }
            .left-column, .right-column {
                flex: 1;
            }
            .section {
                margin-bottom: 15px;
                padding: 10px;
                border: 1px solid #ccc;
            }
            .combined-section {
                background-color: #f9f9f9;
                padding: 10px;
                border: 2px solid #000;
            }
            .section-title {
                font-weight: bold;
                font-size: 14px;
                margin-bottom: 8px;
                text-decoration: underline;
            }
            .combined-title {
                font-weight: bold;
                font-size: 15px;
                margin-bottom: 10px;
                text-align: center;
                border-bottom: 1px solid #000;
                padding-bottom: 5px;
            }
            .sub-section-title {
                font-weight: bold;
                font-size: 13px;
                margin-top: 10px;
                margin-bottom: 5px;
                text-decoration: underline;
            }
            .detail-row {
                margin: 5px 0;
                display: flex;
            }
            .label {
                font-weight: bold;
                width: 160px;
                display: inline-block;
            }
            .value {
                flex: 1;
            }
            .table {
                width: 100%;
                border-collapse: collapse;
                margin: 10px 0;
            }
            .table th, .table td {
                border: 1px solid #000;
                padding: 6px;
                text-align: left;
            }
            .table th {
                background-color: #f0f0f0;
                font-weight: bold;
            }
            .info-text {
                font-size: 11px;
                color: #666;
                margin-top: 15px;
                text-align: center;
                border-top: 1px solid #ccc;
                padding-top: 8px;
            }
            .surcharge-table {
                font-size: 11px;
            }
            @media print {
                body { 
                    font-family: 'Courier New', monospace; 
                    padding: 20px; 
                    font-size: 11px;
                }
                .main-container {
                    page-break-inside: avoid;
                }
            }
           @media print {
    button[onclick="window.print()"], 
    .print-button {
        display: none !important;
    }
    /* Hide any other UI elements too */
    .info-text {
        color: black; /* Ensure success message prints */
    }
}


        </style>
    </head>
    <body>
        <div class="container">
            <div class="header">
                <h1>New Terminal </h1>
                <div class="info-text" style="color:green"><b>Configuration Saved! The new terminal is ${terminalId}</b> </div>
            </div>
            <div style="text-align: center; margin: 10px 0;">
    <button class="print-button" 
            onclick="window.print()" 
            style="
                background: #28a745; 
                color: white; 
                border: none; 
                padding: 8px 16px; 
                font-size: 14px; 
                font-weight: bold; 
                border-radius: 4px; 
                cursor: pointer;
                font-family: 'Courier New', monospace;
            ">
        🖨️ PRINT
    </button>
</div>


            <div class="main-container">
                <!-- Left Column: Location Information -->
                <div class="left-column">
                    <div class="section">
                        <div class="detail-row">
                            <span class="label">Location Name:</span>
                            <span class="value" id="location-name"></span>
                        </div>
                        <div class="detail-row">
                            <span class="label">Address:</span>
                            <span class="value" id="address"></span>
                        </div>
                        <div class="detail-row">
                            <span class="label">City:</span>
                            <span class="value" id="city"></span>
                        </div>
                        <div class="detail-row">
                            <span class="label">State/Province:</span>
                            <span class="value" id="state"></span>
                        </div>
                        <div class="detail-row">
                            <span class="label">Zip Code:</span>
                            <span class="value" id="zipcode"></span>
                        </div>
                        <div class="detail-row">
                            <span class="label">Time Zone:</span>
                            <span class="value" id="timezone"></span>
                        </div>
                        <div class="detail-row">
                            <span class="label">Location Type:</span>
                            <span class="value" id="location-type"></span>
                        </div>
                    </div>
                </div>
                
                <!-- Right Column: Combined Terminal Info, Fees, and Adv Functions -->
                <div class="right-column">
                    <div class="section">
                        <div class="detail-row">
                            <span class="label">Make & Model:</span>
                            <span class="value" id="make-model"></span>
                        </div>
                        <div class="detail-row">
                            <span class="label">Serial Number:</span>
                            <span class="value" id="serial-number"></span>
                        </div>
                         <div class="detail-row">
                            <span class="label">Fees</span>
                        </div>
                        <div class="detail-row">
                            <span class="label">Type:</span>
                            <span class="value" id="fee-type"></span>
                        </div>
                        <div class="detail-row">
                            <span class="label">Amount:</span>
                            <span class="value" id="fee-amount"></span>
                        </div>
                        <div class="detail-row">
                            <span class="label">Adv. Functions:</span>
                            <span class="value" id="block-ebt"></span>
                        </div>
                        <div class="sub-section-title"></div>
                        <div class="detail-row">
                            <span class="label">Gateway:</span>
                            <span class="value" id="block-ebt"></span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="section">
                <div class="section-title">Cassettes</div>
                <div class="detail-row">
                    <span class="label">How many cassettes?</span>
                    <span class="value" id="cassette-count"></span>
                </div>
                <div id="cassettes-list"></div>
            </div>
            
            <div class="section">
                <div class="section-title">Terminal ACH Distribution - Cash replenishment Account</div>
                <div class="detail-row">
                    <span class="label">Account:</span>
                    <span class="value" id="ach-account"></span>
                </div>
            </div>
            
            <div class="section">
                <div class="section-title">Surcharge Accounts</div>
                <table class="table surcharge-table">
                    <thead>
                        <tr>
                            <th>Account</th>
                            <th>Type</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td id="surcharge-account-1"></td>
                            <td id="surcharge-type-1"></td>
                            <td id="surcharge-value-1"></td>
                        </tr>
                        <tr>
                            <td id="surcharge-account-2"></td>
                            <td id="surcharge-type-2"></td>
                            <td id="surcharge-value-2"></td>
                        </tr>
                        <tr>
                            <td id="surcharge-account-3"></td>
                            <td id="surcharge-type-3"></td>
                            <td id="surcharge-value-3"></td>
                        </tr>
                        <tr>
                            <td id="surcharge-account-4"></td>
                            <td id="surcharge-type-4"></td>
                            <td id="surcharge-value-4"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div class="section">
                <div class="section-title">Contacts</div>
                <table class="table">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Phone</th>
                            <th>Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td id="contact1-Name"></td>
                            <td id="contact1-Phone"></td>
                            <td id="contact1-EMail"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
    <table class="table" style="width: 100%; margin-top: 8px;">
        <thead>
            <tr>
                <th style="border: 1px solid #000; padding: 6px; font-weight: bold;">Notes</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td id="notes" style="
                    max-height: 100px; 
                    overflow-y: auto; 
                    word-wrap: break-word; 
                    padding: 8px; 
                    font-size: 11px;
                    line-height: 1.3;
                    border: 1px solid #ddd;
                    background: #fafafa;
                "></td>
            </tr>
        </tbody>
    </table>
    </body>
    </html>
    `);

        printWindow.document.close();
        printWindow.focus();

        // Fetch and populate data
        try {
            const [detailsRes] = await Promise.all([
                axios.get(`${getPrintTerminalDetailsByIDApi}?termId=${terminalId}`),
            ]);

            const details = detailsRes?.data?.response[0]  || null;



            consoleHelper(" data ",details);
            // Populate location information
            if (details) {
                updateElement(printWindow, 'location-name', details.locationName || '');
                updateElement(printWindow, 'address', details.address || '');
                updateElement(printWindow, 'city', details.city || '');
                updateElement(printWindow, 'state', details.state|| '');
                updateElement(printWindow, 'zipcode', details.zipCode || '');
                updateElement(printWindow, 'timezone', details.timeZone || ' ');
                updateElement(printWindow, 'location-type', details.locationType || '');
            }

            // Populate terminal information
            if (details) {
                updateElement(printWindow, 'make-model', details.makeModel || '');
                updateElement(printWindow, 'serial-number', details.serialNumber || '');
            }

            // Populate fees (print view only): API often returns feesType as "2" (fixed) / "3" (percentage)
            const rawPrintFeeType = details?.feesType;
            let printFeeTypeNorm = rawPrintFeeType == null ? '' : String(rawPrintFeeType).trim();
            if (printFeeTypeNorm === 'null' || printFeeTypeNorm === 'undefined') {
                printFeeTypeNorm = '';
            }
            const printIsPercentage =
                printFeeTypeNorm === '3' || /percentage/i.test(printFeeTypeNorm);
            const printIsFixed =
                printFeeTypeNorm === '2' || /fixed/i.test(printFeeTypeNorm);
            const printFeeTypeLabel = printIsPercentage
                ? 'Percentage'
                : printIsFixed
                  ? 'Fixed Dollar'
                  : printFeeTypeNorm || 'Fixed Dollar';
            const printFeeVal = details?.feeValue;
            let printFeeAmountText = '';
            if (printFeeVal != null && printFeeVal !== '') {
                const n = Number(printFeeVal);
                printFeeAmountText = printIsPercentage
                    ? `${Number.isFinite(n) ? n : printFeeVal}%`
                    : `$${Number.isFinite(n) ? n.toFixed(2) : printFeeVal}`;
            }
            updateElement(printWindow, 'fee-type', printFeeTypeLabel);
            updateElement(printWindow, 'fee-amount', printFeeAmountText);

            // Populate adv functions (avoid 'DCC: undefined': + runs before ||, so || never saw a "missing" value)
            const blockEbtVal = details?.blockEBT;
            const dccLabel =
                blockEbtVal === true || blockEbtVal === 'true' || blockEbtVal === 'True'
                    ? 'True'
                    : blockEbtVal === false || blockEbtVal === 'false' || blockEbtVal === 'False'
                      ? 'False'
                      : blockEbtVal == null || blockEbtVal === ''
                        ? 'False'
                        : String(blockEbtVal);
            updateElement(printWindow, 'block-ebt', 'DCC: ' + dccLabel);

            // Populate cassettes (dynamic rows)
            updateElement(printWindow, 'cassette-count', details?.cassettes || 0);
            (function renderCassettes() {
                const listEl = printWindow.document.getElementById('cassettes-list');
                if (!listEl) return;
                const total = Number(details?.cassettes || 0);
                let html = '';
                for (let i = 1; i <= total; i++) {
                    const cents = Number(details?.[`cassette${i}Value`] || 0);
                    if (cents > 0) {
                        const dollars = cents / 100;
                        html += `
                        <div class="detail-row">
                            <span class="label">Cassette ${i}:</span>
                            <span class="value">$${dollars.toFixed(2)}</span>
                        </div>`;
                    }
                }
                // If no cassette values found, still show a placeholder
                if (!html && total > 0) {
                    html = `
                    <div class="detail-row">
                        <span class="label">Cassette 1:</span>
                        <span class="value">N/A</span>
                    </div>`;
                }
                listEl.innerHTML = html;
            })();


            // Populate ACH account
            if (details.settlementAccount) {
                updateElement(printWindow, 'ach-account', `${details?.[`settlementAccount`] || ''}`);
            }

            // Populate surcharge accounts
            // Populate surcharge accounts - only show rows with data
            [1,2,3,4].forEach(num => {
                const account = details?.[`surcharge${num}Account`] ?? '';
                const type = details?.[`surcharge${num}Type`] ?? 'Fixed';
                const value = details?.[`surcharge${num}Percentage`] ?? 0;

                // Only update elements if there's actual data
                if (account || type !== 'Fixed' || value !== 0) {
                    updateElement(printWindow, `surcharge-account-${num}`, account);
                    updateElement(printWindow, `surcharge-type-${num}`, type);
                    updateElement(printWindow, `surcharge-value-${num}`,
                        type === '%' || type === 'Percentage'
                            ? `${Math.round(value)}%`
                            : `$${parseFloat(value || 0).toFixed(2)}`
                    );
                }
            });

            // Populate contacts
            [1,2,3].forEach(i => {
                const fields = ['Name', 'Phone', 'Fax', 'EMail'];  // ✅ Capital E matches your data
                fields.forEach(field => {
                    const value = details?.[`contact${field}${i}`] ?? '';
                    updateElement(printWindow, `contact${i}-${field}`, value);
                });
            });





            // Populate notes
            updateElement(printWindow, 'notes', details.notes || 'N/A');

        } catch (error) {
            console.error("Error fetching terminal details:", error);
        }

        return Promise.resolve();
    };

// Helper function to update element content
    function updateElement(printWindow, elementId, content) {
        const element = printWindow.document.getElementById(elementId);
        if (element) {
            element.textContent = content || 'N/A';
        }
    }

    const onSubmit = (data, e) => {
        //e.target.reset();
       // reset();// reset after form submit
        //alert(settlementValue?.label);
        console.log(data.paramStateText," ------ ",selectedRegionValue?.value)
        if (typeof selectedRegionValue?.value === 'undefined') {
            setSelectedCassetteValue({label:"1",value:'1'})
        }
        if(data.paramStateText === '0SEPRATOR0'){
            alert("Please provide State!")
            return false;
        }
        if(data.paramLCType === '-1'){
            alert("Please provide Location Type!")
            return false;
        }
        if(data.paramModelID === '0SEPRATOR0'){
            alert("Please provide Terminal Model!")
            return false;
        }
        if(data.paramCassettes1 === '-1'){
            alert("Please provide Cassettes!")
            return false;
        }
        if(settlementValue === undefined){
            alert("Please provide settlement Account!")
            return false;
        }
        if(settlementValue1?.value === undefined){
            alert("Please provide surcharge Account!")
            return false;
        }
        //console.log(data.paramCassettes," ------ ",selectedCassetteValue)
        if (typeof selectedCassetteValue?.value === 'undefined') {
           setSelectedCassetteValue({label:"1",value:'1'})
        }
        axios.get(
            `saveTerminalDetails?data=${encodeURI(JSON.stringify(data))}&paramStateText=${selectedRegionValue?.value}
            &paramCassettes=${selectedCassetteValue?.value}&settlementValue=${settlementValue?.value}&settlementValue1=${settlementValue1?.value}
            &settlementValue2=${settlementValue2?.value}&settlementValue3=${settlementValue3?.value}&settlementValue4=${settlementValue4?.value}
            &userID=${loggedUserStorage}&paramSettlementText=${settlementValue?.label}&paramSurcharge1Text=${settlementValue1?.label}
            &paramSurcharge2Text=${settlementValue2?.label}&paramSurcharge3Text=${settlementValue3?.label}&paramSurcharge4Text=${settlementValue4?.label}`
        )
            .then(res => {
                window.scrollTo(0, 0);
                const newTerminalID = res?.data?.response?.[0]?.resultSet;
                setTerminalID(res?.data?.response?.[0]?.resultSet);
                if (res?.data?.response?.[0]?.resultSet != null) {

                    setShowTerminalDiv(true);

                    // Call print function
                    printTerminalDetails(newTerminalID)
                        .then(() => {
                            console.log("Terminal details printed successfully");
                        })
                        .catch(error => {
                            console.error("Error printing terminal details:", error);
                        });
                } else {
                    setShowTerminalDiv(false);
                }
                setTimeout(() => {
                    setShowTerminalDiv(false);
                }, 1000000);
                console.log(res?.data?.response?.[0]?.resultSet != null," terminal ID ",terminalID,res?.data?.response?.[0]?.resultSet)
            })
    };

    const handleChange  = (e) => {
        setSelectedCassetteValue((e));
    };

    const handleRegionChange  = (e) => {
        setRegionValue((e));

        ConsoleHelper(" ---- Region Value",selectedRegionValue)
    };


    const styles = {
        container: {
            width: "80%",
            margin: "0 auto",
        },
        input: {
            width: "100%",
        },
    };

    const errorStyle = {
        input: {
            fontfamily: "Arial, Helvetica, sans-serif",
            color: "red",
            fontSize: "10px",
            textAlign: 'right',
            flex:1,
        },
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '30px',
            height: '30px',
            boxShadow: state.isFocused ? null : null,
        }),

        valueContainer: (provided, state) => ({
            ...provided,
            height: '30px',
            padding: '0 6px'
        }),

        input: (provided, state) => ({
            ...provided,
            margin: '0px',
            width: "9vw",
        }),
        indicatorSeparator: state => ({
            display: 'none',
        }),
        indicatorsContainer: (provided, state) => ({
            ...provided,
            height: '30px',
        }),
    };

    useEffect(() => {
        setCassetteOptions([
            { label: "1", value: "1" },
            { label: "2", value: "2" },
            { label: "3", value: "3" },
            { label: "4", value: "4" },
            { label: "5", value: "5" },
            { label: "6", value: "6" },
        ]);
        setSelectedCassetteValue(
            { label: "1", value: "1" }
        );
      /*  printTerminalDetails('USB00102')
            .then(() => {
                console.log("Terminal details printed successfully");
            })
            .catch(error => {
                console.error("Error printing terminal details:", error);
            });*/

        const getBankingSettlementAccountInfo = async () => {
            const result = await axios.get(`${getBankingSettlementAccountInfoApi}?paramSourceType=1&paramSourceCode=Administrator&paramDestType=4&paramDestCode=-1&paramAssignCode=1&paramCurrentUserID=${loggedUserStorage}`);
            setSettlementOptions(result?.data);

            const resultRegions = await axios.get(`${getRegionsDetailsApi}`,{
                mode: 'no-cors' // 'cors' by default
            });
            setRegionOptions(resultRegions?.data);
        };
        getBankingSettlementAccountInfo();
        return () => {
        };
    }, []);

    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="card">
                    <div className="card-body">
                      <form onSubmit={handleSubmit(onSubmit)}>
                          {showTerminalDiv ? (
                              <div className="row">
                                  <div className="col-md-12">
                                      {terminalID.includes("Exception") && <label htmlFor="exampleInputEmail1" style={{color:"red",fontWeight:"bold"}}>Error Occured while Saving: Please Try Again !!</label>}
                                      {!terminalID.includes("Exception") && <label htmlFor="exampleInputEmail1" style={{color:"green",marginLeft: "30%",fontWeight:"bold"}}>Terminal ID Created : {terminalID}</label>}

                                  </div>
                              </div>
                              ):("")}

                          {(history.location.pathname.includes("localhost")) ? (
                              console.log("RENDERING  FOR CANADA.........")
                          ):("")}
                        <div className="row">
                            <div className="col-md-6">
                                <h5 className="tbsub-title mt-3 mb-3">Terminal Setup Info</h5>
                                <div className="col-md-12">
                                    <div className="form-group row">
                                        <label className="control-label col-md-3"> Business/Location Name:</label>
                                        <input type="text" {...register("paramLocationName", { required: "required", maxLength: 20 })}
                                               style={{ ...styles.input, borderColor: errors.paramLocationName && "red" }}
                                               placeholder='Business Location Name'
                                               className={errors.paramLocationName ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'}
                                        />
                                        {errors.paramLocationName && (
                                            <p style={errorStyle.input}>{errors.paramLocationName.message}</p>
                                        )}
                                    </div>
                                        {/*<div className="form-group row">
                                                <label className="control-label col-md-3">Business DBA:</label>
                                                <input type="text" {...register("paramBusinessDBAText", { required: false})}
                                                       className="form-control form-control-sm col-md-9" placeholder="Business DBA"/>
                                        </div>*/}
                                        <div className="form-group row">
                                                <label className="control-label col-md-3">Address:</label>
                                            <input type="text" {...register("paramAddress", { required: "required", maxLength: 200, pattern: { value: /^[a-zA-Z0-9\s]*$/,
                                                    message: "Address can only contain letters, numbers, spaces" } })}
                                                   style={{ ...styles.input, borderColor: errors.paramAddress && "red" }}
                                                      className={errors.paramAddress ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'}  placeholder="Address"/>
                                            {errors.paramAddress && (
                                                <p style={errorStyle.input}>{errors.paramAddress.message}</p>
                                            )}
                                        </div>
                                        <div className="form-group row">
                                                <label className="control-label col-md-3">City:</label>
                                                <input type="text" {...register("paramCity", { required: "required", maxLength: 200 })}
                                                       style={{ ...styles.input, borderColor: errors.paramCity && "red" }}
                                                      className={errors.paramCity ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} placeholder="City"/>
                                            {errors.paramCity && (
                                                <p style={errorStyle.input}>{errors.paramCity.message}</p>
                                            )}
                                        </div>
                                        <div className="form-group row">
                                                <label className="control-label col-md-3">Postal Code:</label>
                                                <input type="text" {...register("paramPostalCode", { required: "required", maxLength: 200 })}
                                                       style={{ ...styles.input, borderColor: errors.paramPostalCode && "red" }}
                                                      className={errors.paramPostalCode ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} placeholder="Zip Code"/>
                                            {errors.paramPostalCode && (
                                                <p style={errorStyle.input}>{errors.paramPostalCode.message}</p>
                                            )}
                                        </div>
                                        <div className="form-group row">
                                                <label className="control-label col-md-3">Region/Province:</label>
                                            <Select
                                                options={regionOptions}
                                                value={selectedRegionValue}
                                                defaultValue={defaultSelectStateOption}
                                                onChange={handleRegionChange}
                                            />
                                        </div>
                                        <div className="form-group row">
                                            <label className="control-label col-md-3"> Time Zone:</label>
                                            <select {...register("paramTimeZoneText", { required: "required", maxLength: 200 })}
                                                    style={{ ...styles.input, borderColor: errors.paramTimeZoneText && "red" }}
                                                    className="form-control form-control-sm col-md-9 select2">
                                                <option value="0SEPRATOR0">Select Type Zone..</option>
                                                <option selected="selected" value="1SEPRATOR(GMT  -5:00) Eastern Time">(GMT  -5:00) Eastern Time</option>
                                                <option value="2SEPRATOR(GMT  -4:00) Atlantic Time">(GMT  -4:00) Atlantic Time</option>
                                                <option value="3SEPRATOR(GMT  -6:00) Central Time">(GMT  -6:00) Central Time</option>
                                                <option value="4SEPRATOR(GMT  -7:00) Mountain Time">(GMT  -7:00) Mountain Time</option>
                                                <option value="5SEPRATOR(GMT  -8:00) Pacific Time">(GMT  -8:00) Pacific Time</option>
                                                <option value="6SEPRATOR(GMT  -3:30) Newfoundland Time">(GMT  -3:30) Newfoundland Time</option>
                                                <option value="7SEPRATOR(GMT  -9:00) Alaska Time">(GMT  -9:00) Alaska Time</option>
                                                <option value="8SEPRATOR(GMT -10:00) Hawaii Time">(GMT -10:00) Hawaii Time</option>
                                                <option value="9SEPRATOR(GMT  -6:00) Indiana Time">(GMT  -6:00) Indiana Time</option>
                                                <option value="10SEPRATOR(GMT  -7:00) Arizona, Northeast BC">(GMT  -7:00) Arizona, Northeast BC</option>
                                                <option value="11SEPRATOR(GMT  -6:00) Saskatchewan Time">(GMT  -6:00) Saskatchewan Time</option>
                                                <option value="12SEPRATOR(GMT +5:30) India Time">(GMT +5:30) India Time</option>
                                            </select>
                                            {errors.paramTimeZoneText && (
                                                <p style={errorStyle.input}>{errors.paramTimeZoneText.message}</p>
                                            )}
                                        </div>
                                        <div className="form-group row">
                                            <label className="control-label col-md-3"> Location Type:</label>
                                            <select className="form-control form-control-sm col-md-9 select2" {...register("paramLCType", { required: "required", maxLength: 200 })}>
                                                <option value="-1">Select Location Type..</option>
                                                <option value="TESTSEPRATORTest Terminals">Test Terminals</option>
                                                <option value="OTHRSEPRATOROther">Other</option>
                                    <option value="LIQRSEPRATORBeer/Liquor/Wine">Beer/Liquor/Wine</option>
                                    <option value="CONVSEPRATORConvenience Store">Convenience Store</option>
                                    <option value="DEPTSEPRATORDepartment Store">Department Store</option>
                                    <option value="DRUGSEPRATORDrug Store">Drug Store</option>
                                    <option value="GASASEPRATORGas Stations/Auto">Gas Stations/Auto</option>
                                    <option value="HARDSEPRATORHardware &amp; Gardening">Hardware &amp; Gardening</option>
                                    <option value="TRVLSEPRATORAirport/Train/Bus">Airport/Train/Bus</option>
                                    <option value="RESTSEPRATORRestaurant</op">Restaurant</option>
                                    <option value="PROFSEPRATORProfessional Services">Professional Services</option>
                                    <option value="SMFSSEPRATORSmall Food Specialty">Small Food Specialty</option>
                                    <option value="SPECSEPRATORSpecialty Store">Specialty Store</option>
                                    <option value="SUPRSEPRATORupermarket">Supermarket</option>
                            <option value="UTILSEPRATORUtility &amp; Government">Utility &amp; Government</option>
                            <option value="BARPSEPRATORBar/Pub">Bar/Pub</option>
                            <option value="GOLFSEPRATORGolf Club</opt">Golf Club</option>
                            <option value="FINASEPRATORFinancial Institution">Financial Institution</option>
                            <option value="MALLSEPRATORShopping Mall">Shopping Mall</option>
                            <option value="HOTLSEPRATORHotel">Hotel</option>
                            <option value="CASISEPRATORCasino">Casino</option>
                            <option value="HOSPSEPRATORHospital">Hospital</option>
                            <option value="COMNSEPRATORCommunity Ctr/Sports Venue">Community Ctr/Sports Venue</option>
                            <option value="CINESEPRATORCinema">Cinema</option>
                            <option value="POOLSEPRATORBilliard Hall">Billiard Hall</option>
                            <option value="BOWLSEPRATORBowling Alley">Bowling Alley</option>
                            <option value="BINGSEPRATORBingo Hall">Bingo Hall</option>
                            <option value="SKIRSEPRATORSki Resort">Ski Resort</option>
                            <option value="CMPSSEPRATORSchool/College Campus">School/College Campus</option>
                                            </select>
                                            {errors.paramLCType && (
                                                <p style={errorStyle.input}>{errors.paramLCType.message}</p>
                                            )}
                                        </div>
                                        {/*<div className="form-group row">
                                                <label className="control-label col-md-3">Business Tax ID#:</label>
                                                <input {...register("paramBusinessTaxIdText", { required: "required", maxLength: 200 })}
                                                       style={{ ...styles.input, borderColor: errors.paramBusinessTaxIdText && "red" }}
                                                      className={errors.paramBusinessTaxIdText ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="number"  id="taxID"/>
                                            {errors.paramBusinessTaxIdText && (
                                                <p style={errorStyle.input}>{errors.paramBusinessTaxIdText.message}</p>
                                            )}
                                        </div>*/}
                                        {/*<div className="form-group row">
                                                <label className="control-label col-md-3"> Years In Business:</label>
                                                <input {...register("paramYearsInBusinessText", {  pattern: {
                                                        value: /^[0-9]+$/,
                                                        message: 'Please enter a number',
                                                        },
                                                    required: "Please enter a number", maxLength: 200 })}
                                                       style={{ ...styles.input, borderColor: errors.paramYearsInBusinessText && "red" }}
                                                      className={errors.paramYearsInBusinessText ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="number" id="businessYrs" />
                                            {errors.paramYearsInBusinessText && (
                                                <p style={errorStyle.input}>{errors.paramYearsInBusinessText.message}</p>
                                            )}

                                        </div>*/}
                                        {/*<div className="form-group row">
                                                <label className="control-label col-md-3">Years At Current Location:</label>
                                                <input {...register("paramYearsAtCurrentLocationText", { required: "required", maxLength: 200 })}
                                                       style={{ ...styles.input, borderColor: errors.paramYearsAtCurrentLocationText && "red" }}
                                                      className={errors.paramYearsAtCurrentLocationText ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="number" id="yrsLocation"/>
                                            {errors.paramYearsAtCurrentLocationText && (
                                                <p style={errorStyle.input}>{errors.paramYearsAtCurrentLocationText.message}</p>
                                            )}
                                        </div>*/}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <h5 className="tbsub-title mt-3 mb-3">&nbsp;</h5>
                                <div className="col-md-12">
                                    {/*<div className="form-group row">
                                            <label className="control-label col-md-3">Type Of Change:</label>
                                            <input type="text" {...register("paramTypeOfChangeText")}

                                                   className="form-control form-control-sm col-md-9" placeholder="Type Of Change"/>
                                    </div>*/}
                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Terminal Brand/Model:</label>
                                        <select {...register("paramModelID", {required: "required"})}
                                                style={{...styles.input, borderColor: errors.paramModelID && "red"}}
                                                required
                                                className="form-control form-control-sm col-md-9 select2">

                                            <option value="0SEPRATOR0">Select Brand &amp; Model..</option>
                                            <option value="97SEPRATORDiebold-CSP 100P">Diebold-CSP 100</option>
                                            <option value="102SEPRATORDiebold-CSP 200P">Diebold-CSP 200P</option>
                                            <option value="13SEPRATORDiebold-CSP 200P">Diebold-CSP 200</option>
                                            <option value="188SEPRATORGenmega-G2500 (Triton Standard 3)">Genmega-G2500
                                                (Triton Standard 3)
                                            </option>
                                            <option value="194SEPRATORGenmega-2500 (Standard 1)">Genmega-2500 (Standard
                                                1)
                                            </option>
                                            <option value="195SEPRATORGenmega-1900 (Triton Standard 3)">Genmega-1900
                                                (Triton Standard 3)
                                            </option>
                                            <option value="196SEPRATORGenmega-1900 (Standard 1)">Genmega-1900 (Standard
                                                1)
                                            </option>
                                            <option value="197SEPRATORGenmega-3000 (Triton Standard 3)">Genmega-3000
                                                (Triton Standard 3)
                                            </option>
                                            <option value="198SEPRATORGenmega-3000 (Standard 1)">Genmega-3000 (Standard
                                                1)
                                            </option>
                                            <option value="199SEPRATORGenmega-5010 (Triton Standard 3)">Genmega-5010
                                                (Triton Standard 3)
                                            </option>
                                            <option value="200SEPRATORGenmega-5010 (Standard 1)">Genmega-5010 (Standard
                                                1)
                                            </option>
                                            <option value="201SEPRATORGenmega-6000 (Triton Standard 3)">Genmega-6000
                                                (Triton Standard 3)
                                            </option>
                                            <option value="202SEPRATORGenmega-5000 (Standard 1)">Genmega-5000 (Standard
                                                1)
                                            </option>
                                            <option value="203SEPRATORGenmega-Onyx (Triton Standard 3)">Genmega-Onyx
                                                (Triton Standard 3)
                                            </option>
                                            <option value="204SEPRATORGenmega-Onyx (Standard 1)">Genmega-Onyx (Standard
                                                1)
                                            </option>
                                            <option value="165SEPRATORHantle-1700 (Triton Standard 3)">Hantle-1700
                                                (Triton Standard 3)
                                            </option>
                                            <option value="166SEPRATORHantle-C4000 (Triton Standard 3)">Hantle-C4000
                                                (Triton Standard 3)
                                            </option>
                                            <option value="173SEPRATORHantle-1700W (Standard 1)">Hantle-1700W (Standard
                                                1)
                                            </option>
                                            <option value="174SEPRATORHantle-1700W (Triton Standard 3)">Hantle-1700W
                                                (Triton Standard 3)
                                            </option>
                                            <option value="87SEPRATORHantle-C4000 (Standard 1)">Hantle-C4000 (Standard
                                                1)
                                            </option>
                                            <option value="136SEPRATORHantle-1700 (Standard 1)">Hantle-1700 (Standard
                                                1)
                                            </option>
                                            <option
                                                value="137SEPRATORNautilus/Hyosung-1500 (Standard 1)">Nautilus/Hyosung-1500
                                                (Standard 1)
                                            </option>
                                            <option
                                                value="138SEPRATORNautilus/Hyosung-1520 (Standard 1)">Nautilus/Hyosung-1520
                                                (Standard 1)
                                            </option>
                                            <option
                                                value="151SEPRATORNautilus/Hyosung-5050 (Standard 1)">Nautilus/Hyosung-5050
                                                (Standard 1)
                                            </option>
                                            <option
                                                value="142SEPRATORNautilus/Hyosung-1500 (Triton Standard 3)">Nautilus/Hyosung-1500
                                                (Triton Standard 3)
                                            </option>
                                            <option
                                                value="143SEPRATORNautilus/Hyosung-1520 (Triton Standard 3)">Nautilus/Hyosung-1520
                                                (Triton Standard 3)
                                            </option>
                                            <option
                                                value="154SEPRATORNautilus/Hyosung-1540 (Triton Standard 3)">Nautilus/Hyosung-1540
                                                (Triton Standard 3)
                                            </option>
                                            <option
                                                value="152SEPRATORNautilus/Hyosung-5050 (Triton Standard 3)">Nautilus/Hyosung-5050
                                                (Triton Standard 3)
                                            </option>
                                            <option
                                                value="145SEPRATORNautilus/Hyosung-1800 (Triton Standard 3)">Nautilus/Hyosung-1800
                                                (Triton Standard 3)
                                            </option>
                                            <option
                                                value="178SEPRATORNautilus/Hyosung-MX 5000SE (Standard 1)">Nautilus/Hyosung-MX
                                                5000SE (Standard 1)
                                            </option>
                                            <option
                                                value="179SEPRATORNautilus/Hyosung-MX 5000SE (Standard 3)">Nautilus/Hyosung-MX
                                                5000SE (Standard 3)
                                            </option>
                                            <option
                                                value="180SEPRATORNautilus/Hyosung-MX 5300CE (Standard 1)">Nautilus/Hyosung-MX
                                                5300CE (Standard 1)
                                            </option>
                                            <option
                                                value="181SEPRATORNautilus/Hyosung-MX 5300CE (Standard 3)">Nautilus/Hyosung-MX
                                                5300CE (Standard 3)
                                            </option>
                                            <option
                                                value="182SEPRATORNautilus/Hyosung-MX 5300XP (Standard 1)">Nautilus/Hyosung-MX
                                                5300XP (Standard 1)
                                            </option>
                                            <option
                                                value="183SEPRATORNautilus/Hyosung-MX 5300XP (Standard 3)">Nautilus/Hyosung-MX
                                                5300XP (Standard 3)
                                            </option>
                                            <option
                                                value="184SEPRATORNautilus/Hyosung-MX 4000W (Standard 1)">Nautilus/Hyosung-MX
                                                4000W (Standard 1)
                                            </option>
                                            <option
                                                value="185SEPRATORNautilus/Hyosung-MX 4000W (Standard 3)">Nautilus/Hyosung-MX
                                                4000W (Standard 3)
                                            </option>
                                            <option
                                                value="186SEPRATORNautilus/Hyosung-2600 Halo (Standard 1)">Nautilus/Hyosung-2600
                                                Halo (Standard 1)
                                            </option>
                                            <option
                                                value="187SEPRATORNautilus/Hyosung-2600 Halo (Standard 3)">Nautilus/Hyosung-2600
                                                Halo (Standard 3)
                                            </option>
                                            <option
                                                value="171SEPRATORNautilus/Hyosung-2700CE (Standard 1)">Nautilus/Hyosung-2700CE
                                                (Standard 1)
                                            </option>
                                            <option
                                                value="172SEPRATORNautilus/Hyosung-2700CE (Triton Standard 3)">Nautilus/Hyosung-2700CE
                                                (Triton Standard 3)
                                            </option>
                                            <option
                                                value="144SEPRATORNautilus/Hyosung-1800 (Standard 1)">Nautilus/Hyosung-1800
                                                (Standard 1)
                                            </option>
                                            <option
                                                value="153SEPRATORNautilus/Hyosung-1540 (Standard 1)">Nautilus/Hyosung-1540
                                                (Standard 1)
                                            </option>
                                            <option value="24SEPRATORNCR-5303 ATM Ease">NCR-5303 ATM Ease</option>
                                            <option value="27SEPRATORNCR-5305 ATM Ease">NCR-5305 ATM Ease</option>
                                            <option value="91SEPRATORTranax-1500">Tranax-1500</option>
                                            <option value="41SEPRATORTranax-1500 (Standar 1)">Tranax-1500 (Standard 1)
                                            </option>
                                            <option value="161SEPRATORTranax-1000 (Triton Standard 3)">Tranax-1000
                                                (Triton Standard 3)
                                            </option>
                                            <option value="149SEPRATORTranax-E4000 (Standard 1)">Tranax-E4000 (Standard
                                                1)
                                            </option>
                                            <option value="162SEPRATORTranax-1500 (Triton Standard 3)">Tranax-1500
                                                (Triton Standard 3)
                                            </option>
                                            <option value="163SEPRATORTranax-2100 (Triton Standard 3)">Tranax-2100
                                                (Triton Standard 3)
                                            </option>
                                            <option value="164SEPRATORTranax-2200 (Triton Standard 3)">Tranax-2200
                                                (Triton Standard 3)
                                            </option>
                                            <option value="9SEPRATORTranax-1000 (Standard 1)">Tranax-1000 (Standard 1)
                                            </option>
                                            <option value="10SEPRATORTranax-2000 (Standard 1)">Tranax-2000 (Standard
                                                1)
                                            </option>
                                            <option value="11SEPRATORTranax-2100 (Standard 1)">Tranax-2100 (Standard
                                                1)
                                            </option>
                                            <option value="12SEPRATORTranax-2200 (Standard 1)">Tranax-2200 (Standard
                                                1)
                                            </option>
                                        </select>
                                        {errors.paramModelID && (
                                            <p style={errorStyle.input}>{errors.paramModelID.message}</p>
                                        )}
                                    </div>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Terminal Serial #:</label>
                                        <input type="text" {...register("paramSerialNo", {
                                            required: "required",
                                            maxLength: 200
                                        })}
                                               style={{...styles.input, borderColor: errors.paramSerialNo && "red"}}
                                               className={errors.paramSerialNo ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'}
                                               placeholder="Terminal Serial #"/>
                                        {errors.paramSerialNo && (
                                            <p style={errorStyle.input}>{errors.paramSerialNo.message}</p>
                                        )}
                                    </div>
                                    <h5 className="tbsub-title mt-3 mb-3">Fees:</h5>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Type:</label>
                                        <select
                                            {...register("paramFeeType", {required: "required"})}
                                            style={{...styles.input, borderColor: errors.paramFeeType && "red"}}
                                            required
                                            className="form-control form-control-sm col-md-9 select2"
                                            onChange={(e) => {
                                                // Reset amount when type changes
                                                setValue("paramFeeAmount", "");
                                            }}
                                        >
                                            <option value="2SEPRATORFixedDollar">FixedDollar</option>
                                            <option value="3SEPRATORPercentage">Percentage</option>
                                        </select>
                                        {errors.paramFeeType && (
                                            <p style={errorStyle.input}>{errors.paramFeeType.message}</p>
                                        )}
                                    </div>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Amount:</label>
                                        <input
                                            type="text"
                                            {...register("paramFeeAmount", {
                                                required: "required",
                                                maxLength: 200,
                                                pattern: {
                                                    value: function (value) {
                                                        const feeType = getValues("paramFeeType");
                                                        if (feeType === "3SEPRATORPercentage") {
                                                            // Only integers for percentage
                                                            return /^\d+$/.test(value);
                                                        }
                                                        return true; // Allow decimals for FixedDollar
                                                    },
                                                    message: "Percentage must be whole number (no decimals)"
                                                }
                                            })}
                                            style={{...styles.input, borderColor: errors.paramFeeAmount && "red"}}
                                            className={errors.paramFeeAmount ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'}
                                            placeholder="Amount"
                                            onKeyPress={(e) => {
                                                const feeType = getValues("paramFeeType");
                                                if (feeType === "3SEPRATORPercentage" && e.key === '.') {
                                                    e.preventDefault(); // Block decimal point
                                                }
                                            }}
                                            onPaste={(e) => {
                                                const feeType = getValues("paramFeeType");
                                                if (feeType === "3SEPRATORPercentage") {
                                                    const pastedData = e.clipboardData.getData('text');
                                                    if (pastedData.includes('.')) {
                                                        e.preventDefault();
                                                    }
                                                }
                                            }}
                                        />
                                        {errors.paramFeeAmount && (
                                            <p style={errorStyle.input}>{errors.paramFeeAmount.message}</p>
                                        )}
                                    </div>

                                    <div className="form-group row">
                                        <h5 className="tbsub-title mt-3 mb-3 col-md-6">Adv. Functions:</h5>
                                        <div className="col-md-6" style={{paddingTop: "15px"}}>
                                            <input {...register("paramBlockEBT")}
                                                   className="form-check-input" type="checkbox" value=""
                                                   id="flexCheckDefault"/>
                                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                                DCC
                                            </label>
                                        </div>
                                    </div>

                                    {/* <div className="form-group row">
                                        <label className="control-label col-md-3">Location Contact:</label>
                                        <input {...register("paramLocationContactText", { required: "required", maxLength: 200 })}
                                               style={{ ...styles.input, borderColor: errors.paramLocationContactText && "red" }}
                                              className={errors.paramLocationContactText ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text"  placeholder="Location Contact"/>
                                        {errors.paramLocationContactText && (
                                            <p style={errorStyle.input}>{errors.paramLocationContactText.message}</p>
                                        )}
                                    </div>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3">Location Phone:</label>
                                        <input {...register("paramLocationPhoneText", { required: "required",minLength:{
                                                value: 10,
                                                message: '<p>invalid Phone Number</p>' // JS only: <p>error message</p> TS only support string
                                            }, maxLength : {
                                                value: 10,
                                                message: '<p>invalid Phone Number</p>' // JS only: <p>error message</p> TS only support string
                                            }})}
                                               style={{ ...styles.input, borderColor: errors.paramLocationPhoneText && "red" }}
                                              className={errors.paramLocationPhoneText ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="number"  placeholder="Location Phone:"/>
                                        {errors.paramLocationPhoneText && (
                                            <p style={errorStyle.input}>{errors.paramLocationPhoneText.message}</p>
                                        )}
                                    </div>*/}
                                </div>
                            </div>
                        </div>
                          <hr/>
                          {/* START OF CASSESTES*/}
                          <div className="row">
                              <div className="col-md-12">
                                  <h5 className="tbsub-title mt-3 mb-3" style={{textAlign: "center"}}>Cassettes (Minimum
                                      1 cassette)</h5>
                                  <div className="col-md-12">
                                      <div className="form-group row">
                                          <label className="control-label col-md-3"> How many cassettes?:</label>
                                          {/*<select {...register("paramCassettes")}
                                                style={{ ...styles.input, borderColor: errors.paramCassettes && "red" }}
                                                className="form-control form-control-sm col-md-9 select2"
                                                  value={selectedCassetteValue}
                                                  onChange={handleCassetteSelectChange(this)}>
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                        </select>*/}
                                          {/*<select value={selectedCassetteValue} onChange={handleChange} {...register("paramCassettes")}>
                                            {options.map(option => (
                                                <option key={option.label} value={option.label}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>*/}
                                          <Select
                                              options={options}
                                              value={selectedCassetteValue}
                                              defaultValue={defaultSelectOption}
                                              onChange={handleChange}
                                        />
                                        {/*<Select {...register("paramCassettes")}
                                            options={cassetteOptions}
                                            value={selectedCassetteValue}
                                            filterOption={createFilter({ignoreAccents: false})}
                                            captureMenuScroll={false}
                                            classNamePrefix="custom-select"
                                            components={{Option: CustomOption, MenuList: CustomMenuList}}
                                            styles={customStyles}
                                                onChange={handleCassetteSelectChange}
                                        />*/}
                                    </div>

                                    <div className="form-group row">
                                        <label className="control-label col-md-3"> Cassette 1: (Denomination $)</label>
                                        <select {...register("paramCassette1")}
                                                style={{ ...styles.input, borderColor: errors.paramCassette1 && "red" }}
                                                className="form-control form-control-sm col-md-9 select2">
                                            <option value="1">1</option>
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    {(selectedCassetteValue?.value == "2" || selectedCassetteValue?.value == "3"
                                        || selectedCassetteValue?.value == "4" || selectedCassetteValue?.value == "5"
                                        || selectedCassetteValue?.value == "6") &&(
                                            <>
                                        <div className="form-group row">
                                            <label className="control-label col-md-3"> Cassette 2: (Denomination $)</label>
                                            <select {...register("paramCassette2")}
                                                    style={{ ...styles.input, borderColor: errors.paramCassette2 && "red" }}
                                                    className="form-control form-control-sm col-md-9 select2">
                                                <option value="1">1</option>
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        </div>
                                            </>
                                        )}
                                    {(selectedCassetteValue?.value == "3"|| selectedCassetteValue?.value == "4"|| selectedCassetteValue?.value == "5" || selectedCassetteValue?.value == "6") && (
                                        <>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3"> Cassette 3: (Denomination $)</label>
                                        <select {...register("paramCassette3")}
                                                style={{ ...styles.input, borderColor: errors.paramCassette3 && "red" }}
                                                className="form-control form-control-sm col-md-9 select2">
                                            <option value="1">1</option>
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                        </>
                                    )}
                                    {(selectedCassetteValue?.value == "4" || selectedCassetteValue?.value == "5" || selectedCassetteValue?.value == "6")&& (
                                        <>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3"> Cassette 4: (Denomination $)</label>
                                        <select {...register("paramCassette4")}
                                                style={{ ...styles.input, borderColor: errors.paramCassette4 && "red" }}
                                                className="form-control form-control-sm col-md-9 select2">
                                            <option value="1">1</option>
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                </>
                                )}
                                    {(selectedCassetteValue?.value == "5" || selectedCassetteValue?.value == "6") && (
                                        <>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3"> Cassette 5: (Denomination $)</label>
                                        <select {...register("paramCassette5")}
                                                style={{ ...styles.input, borderColor: errors.paramCassette5 && "red" }}
                                                className="form-control form-control-sm col-md-9 select2">
                                            <option value="1">1</option>
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                        </>
                                    )}
                                    {selectedCassetteValue?.value == "6" && (
                                        <>
                                    <div className="form-group row">
                                        <label className="control-label col-md-3"> Cassette 6: (Denomination $)</label>
                                        <select {...register("paramCassette6")}
                                                style={{ ...styles.input, borderColor: errors.paramCassette6 && "red" }}
                                                className="form-control form-control-sm col-md-9 select2">
                                            <option value="1">1</option>
                                            <option value="5">5</option>
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        {/* START OF TERMINAL ACH DISTRO*/}
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className="tbsub-title mt-3 mb-3" style={{textAlign:"center"}}>Terminal ACH Distribution   - Cash replenishment Account</h5>
                                <div className="col-md-12" style={{textAlign:"end"}}>
                                    <a href="javascript: void(0);">DOWNLOAD EXHIBIT C</a>
                                </div>
                                <h5 className="tbsub-title mt-3 mb-3">Account (Bank Name - Routing Number - Account Number)</h5>
                                <div className="col-md-12">

                                    <div className="form-group row">
                                        <Select {...register("paramSettlementText", { required: false, maxLength: 200 })} required
                                                style={{ ...styles.input, borderColor: errors.paramSettlementText && "red" }}
                                            value={settlementValue
                                            }
                                            options={settlementOptions}
                                            onChange={setSettlementValue}
                                            styles={{
                                                container: (provided) => ({
                                                    ...provided,
                                                    flex: 1,
                                                    width: "400px",
                                                }),
                                            }}
                                                filterOption={createFilter({ ignoreAccents: false })}
                                                captureMenuScroll={false}
                                                classNamePrefix="custom-select"
                                                components={{ Option: CustomOption, MenuList: CustomMenuList }}
                                            menuPortalTarget={document.body}
                                            menuPosition={"fixed"}
                                        />

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* START OF SURCHARGE ACCOUNTS*/}
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className="tbsub-title mt-3 mb-3" style={{textAlign:"center"}}>Surcharge Accounts</h5>
                                <div className="col-md-12" style={{textAlign:"end"}}>
                                    <a href="javascript: void(0);">DOWNLOAD EXHIBIT C</a>
                                </div>
                                <table className="table">
                                    <thead>
                                    <tr>
                                        <th scope="col"><h5>Account (Bank Name - Routing Number - Account Number)</h5></th>
                                        <th scope="col">Type</th>
                                        <th scope="col">Value</th>
                                        {loggedUserStorage === 'Administrator' ? (
                                            <th scope="col">Interac/Non-Interac</th>
                                        ) : <th scope="col">&nbsp;</th>}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>
                                            <Select {...register("paramSurcharge1Text", {
                                                required: false,
                                                maxLength: 200
                                            })}
                                                    style={{
                                                        ...styles.input,
                                                        borderColor: errors.paramSurcharge1Text && "red"
                                                    }}
                                                    value={settlementValue1
                                                    }
                                                    options={settlementOptions}
                                                    onChange={setSettlementValue1}
                                                    styles={{
                                                        container: (provided) => ({
                                                            ...provided,
                                                            flex: 1,
                                                            width: "400px",
                                                        }),
                                                    }}
                                                    filterOption={createFilter({ignoreAccents: false})}
                                                    captureMenuScroll={false}
                                                    classNamePrefix="custom-select"
                                                    components={{Option: CustomOption, MenuList: CustomMenuList}}
                                                    menuPortalTarget={document.body}
                                                    menuPosition={"fixed"}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm col-md-9 select2"
                                                {...register("paramSurchargeType1Text", {
                                                    required: false,
                                                    maxLength: 200
                                                })}
                                                onChange={(e) => setValue("paramSurchargePercentage1Text", "")} // Reset input
                                            >
                                                <option value="1">Fixed</option>
                                                <option value="0">%</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                className="form-control form-control-sm col-md-6"
                                                type="text"
                                                placeholder="($)Value"
                                                {...register("paramSurchargePercentage1Text", {
                                                    required: false,
                                                    maxLength: 200,
                                                    validate: (value) => {
                                                        const type = getValues("paramSurchargeType1Text");
                                                        if (type === "0" && !/^\d+$/.test(value)) { // % selected
                                                            return "Percentage must be whole number";
                                                        }
                                                        return true;
                                                    }
                                                })}
                                                onKeyPress={(e) => {
                                                    const type = getValues("paramSurchargeType1Text");
                                                    if (type === "0" && e.key === '.') { // Block decimal for %
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </td>


                                        <td>
                                            {loggedUserStorage === 'Administrator' ? (
                                                <select className="form-control form-control-sm col-md-9 select2"
                                                        {...register("paramInterac1Text", {
                                                            required: false,
                                                            maxLength: 200
                                                        })}>
                                                    <option value="1">Interac</option>
                                                    <option value="2">Non-Interac</option>
                                                </select>
                                            ) : null}
                                        </td>


                                    </tr>
                                    <tr>
                                        <td>
                                            <Select {...register("paramSurcharge2Text", {
                                                required: false,
                                                maxLength: 200
                                            })}
                                                    style={{
                                                        ...styles.input,
                                                        borderColor: errors.paramSurcharge2Text && "red"
                                                    }}
                                                    value={settlementValue2
                                                    }
                                                    options={settlementOptions}
                                                    onChange={setSettlementValue2}
                                                    styles={{
                                                        container: (provided) => ({
                                                            ...provided,
                                                            flex: 1,
                                                            width: "400px",
                                                        }),
                                                    }}
                                                    filterOption={createFilter({ignoreAccents: false})}
                                                    captureMenuScroll={false}
                                                    classNamePrefix="custom-select"
                                                    components={{Option: CustomOption, MenuList: CustomMenuList}}
                                                    menuPortalTarget={document.body}
                                                    menuPosition={"fixed"}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm col-md-9 select2"
                                                {...register("paramSurchargeType2Text", {
                                                    required: false,
                                                    maxLength: 200
                                                })}
                                                onChange={(e) => setValue("paramSurchargePercentage2Text", "")} // Reset input
                                            >
                                                <option value="1">Fixed</option>
                                                <option value="0">%</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                className="form-control form-control-sm col-md-6"
                                                type="text"
                                                placeholder="($)Value"
                                                {...register("paramSurchargePercentage2Text", {
                                                    required: false,
                                                    maxLength: 200,
                                                    validate: (value) => {
                                                        const type = getValues("paramSurchargeType2Text");
                                                        if (type === "0" && !/^\d+$/.test(value)) { // % selected
                                                            return "Percentage must be whole number";
                                                        }
                                                        return true;
                                                    }
                                                })}
                                                onKeyPress={(e) => {
                                                    const type = getValues("paramSurchargeType2Text");
                                                    if (type === "0" && e.key === '.') { // Block decimal for %
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </td>


                                        <td>
                                            {loggedUserStorage === 'Administrator' ? (
                                                <select className="form-control form-control-sm col-md-9 select2"
                                                        {...register("paramInterac2Text", {
                                                            required: false,
                                                            maxLength: 200
                                                        })}>
                                                    <option value="1">Interac</option>
                                                    <option value="2">Non-Interac</option>
                                                </select>
                                            ) : null}
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            <Select {...register("paramSurcharge3Text", {
                                                required: false,
                                                maxLength: 200
                                            })}
                                                    style={{
                                                        ...styles.input,
                                                        borderColor: errors.paramSurcharge3Text && "red"
                                                    }}
                                                    value={settlementValue3
                                                    }
                                                    options={settlementOptions}
                                                    onChange={setSettlementValue3}
                                                    styles={{
                                                        container: (provided) => ({
                                                            ...provided,
                                                            flex: 1,
                                                            width: "400px",
                                                        }),
                                                    }}
                                                    filterOption={createFilter({ignoreAccents: false})}
                                                    captureMenuScroll={false}
                                                    classNamePrefix="custom-select"
                                                    components={{Option: CustomOption, MenuList: CustomMenuList}}
                                                    menuPortalTarget={document.body}
                                                    menuPosition={"fixed"}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm col-md-9 select2"
                                                {...register("paramSurchargeType3Text", {
                                                    required: false,
                                                    maxLength: 200
                                                })}
                                                onChange={(e) => setValue("paramSurchargePercentage3Text", "")} // Reset input
                                            >
                                                <option value="1">Fixed</option>
                                                <option value="0">%</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                className="form-control form-control-sm col-md-6"
                                                type="text"
                                                placeholder="($)Value"
                                                {...register("paramSurchargePercentage3Text", {
                                                    required: false,
                                                    maxLength: 200,
                                                    validate: (value) => {
                                                        const type = getValues("paramSurchargeType3Text");
                                                        if (type === "0" && !/^\d+$/.test(value)) { // % selected
                                                            return "Percentage must be whole number";
                                                        }
                                                        return true;
                                                    }
                                                })}
                                                onKeyPress={(e) => {
                                                    const type = getValues("paramSurchargeType3Text");
                                                    if (type === "0" && e.key === '.') { // Block decimal for %
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </td>


                                        <td>
                                            {loggedUserStorage === 'Administrator' ? (
                                                <select className="form-control form-control-sm col-md-9 select2"
                                                        {...register("paramInterac3Text", {
                                                            required: false,
                                                            maxLength: 200
                                                        })}>
                                                    <option value="1">Interac</option>
                                                    <option value="2">Non-Interac</option>
                                                </select>
                                            ) : null}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Select {...register("paramSurcharge4Text", {
                                                required: false,
                                                maxLength: 200
                                            })}
                                                    style={{
                                                        ...styles.input,
                                                        borderColor: errors.paramSurcharge4Text && "red"
                                                    }}
                                                    value={settlementValue4
                                                    }
                                                    options={settlementOptions}
                                                    onChange={setSettlementValue4}
                                                    styles={{
                                                        container: (provided) => ({
                                                            ...provided,
                                                            flex: 1,
                                                            width: "400px",
                                                        }),
                                                    }}
                                                    filterOption={createFilter({ignoreAccents: false})}
                                                    captureMenuScroll={false}
                                                    classNamePrefix="custom-select"
                                                    components={{Option: CustomOption, MenuList: CustomMenuList}}
                                                    menuPortalTarget={document.body}
                                                    menuPosition={"fixed"}
                                            />
                                        </td>
                                        <td>
                                            <select
                                                className="form-control form-control-sm col-md-9 select2"
                                                {...register("paramSurchargeType4Text", {
                                                    required: false,
                                                    maxLength: 200
                                                })}
                                                onChange={(e) => setValue("paramSurchargePercentage4Text", "")} // Reset input
                                            >
                                                <option value="1">Fixed</option>
                                                <option value="0">%</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input
                                                className="form-control form-control-sm col-md-6"
                                                type="text"
                                                placeholder="($)Value"
                                                {...register("paramSurchargePercentage4Text", {
                                                    required: false,
                                                    maxLength: 200,
                                                    validate: (value) => {
                                                        const type = getValues("paramSurchargeType4Text");
                                                        if (type === "0" && !/^\d+$/.test(value)) { // % selected
                                                            return "Percentage must be whole number";
                                                        }
                                                        return true;
                                                    }
                                                })}
                                                onKeyPress={(e) => {
                                                    const type = getValues("paramSurchargeType4Text");
                                                    if (type === "0" && e.key === '.') { // Block decimal for %
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />
                                        </td>

                                        <td>
                                            {loggedUserStorage === 'Administrator' ? (
                                                <select className="form-control form-control-sm col-md-9 select2"
                                                        {...register("paramInterac4Text", {
                                                            required: false,
                                                            maxLength: 200
                                                        })}>
                                                    <option value="1">Interac</option>
                                                    <option value="2">Non-Interac</option>
                                                </select>
                                            ) : null}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                          <span className="tbsub-title mt-3 mb-12"
                                style={{textAlign: "center", color: "red", fontSize: "12px"}}>If the Fee type is 'Percentage', the Surcharchage type must be 'Percentage' and the total must be equal to 100%.</span><br/>
                          <span className="tbsub-title mt-3 mb-12"
                                style={{textAlign: "center", color: "red", fontSize: "12px"}}>If the Fee type is 'Fixed Dollar' and the Surcharge type is 'Percentage', the total must be equal to 100%.</span>
                          {/* START OF CONTACTS*/}
                          <div className="row">
                              <div className="col-md-12">
                                  <h5 className="tbsub-title mt-3 mb-3" style={{textAlign: "center"}}>Contacts</h5>
                                  <table className="table">
                                    <thead>
                                    <tr>
                                        <th scope="col">Name</th>
                                        <th scope="col">Phone</th>
                                        <th scope="col">Email</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>
                                            <input {...register("paramContactName1", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.paramContactName1 && "red" }}
                                                  className={errors.paramContactName1 ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" placeholder="Name"/>
                                            {errors.paramContactName1 && (
                                                <p style={errorStyle.input}>{errors.paramContactName1.message}</p>
                                            )}
                                        </td>
                                        <td>
                                            <input {...register("paramPhone1", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.paramPhone1 && "red" }}
                                                  className={errors.paramPhone1 ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" placeholder="Phone"/>
                                            {errors.paramPhone1 && (
                                                <p style={errorStyle.input}>{errors.paramPhone1.message}</p>
                                            )}
                                        </td>
                                        <td>
                                            <input {...register("paramEMail1", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.paramEMail1 && "red" }}
                                                  className={errors.paramEMail1 ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" placeholder="Email"/>
                                            {errors.paramEMail1 && (
                                                <p style={errorStyle.input}>{errors.paramEMail1.message}</p>
                                            )}
                                        </td>
                                    </tr>
                                    {/*<tr>
                                        <td>
                                            <input {...register("paramContactName2", { required: false, maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.paramContactName2 && "red" }}
                                                   className="form-control form-control-sm col-md-9" type="text" placeholder="Name"/>
                                        </td>
                                        <td>
                                            <input {...register("paramPhone2", { required: false, maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.paramPhone2 && "red" }}
                                                   className="form-control form-control-sm col-md-9" type="text" placeholder="Phone"/>
                                        </td>
                                        <td>
                                            <input {...register("paramEMail2", { required: false, maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.paramEMail2 && "red" }}
                                                   className="form-control form-control-sm col-md-9" type="text" placeholder="Email"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input {...register("paramContactName3", { required: false, maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.paramContactName3 && "red" }}
                                                   className="form-control form-control-sm col-md-9" type="text" placeholder="Name"/>
                                        </td>
                                        <td>
                                            <input {...register("paramPhone3", { required: false, maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.paramPhone3 && "red" }}
                                                   className="form-control form-control-sm col-md-9" type="text" placeholder="Phone"/>
                                        </td>
                                        <td>
                                            <input {...register("paramEMail3", { required: false, maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.paramEMail3 && "red" }}
                                                   className="form-control form-control-sm col-md-9" type="text" placeholder="Email"/>
                                        </td>
                                    </tr>
                                    <tr>
                                            <th scope="col">Owner Of Terminal</th>
                                            <th scope="col">Social Security #</th>
                                            <th scope="col">Driver License/State ID #</th>
                                        <th scope="col">Region/Province Issued</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input {...register("termOwner", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.termOwner && "red" }}
                                                  className={errors.termOwner ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" placeholder="Owner of Terminal"/>
                                            {errors.termOwner && (
                                                <p style={errorStyle.input}>{errors.termOwner.message}</p>
                                            )}
                                        </td>
                                        <td>
                                            <input {...register("ssn", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.ssn && "red" }}
                                                  className={errors.ssn ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" placeholder="Social Security"/>
                                            {errors.ssn && (
                                                <p style={errorStyle.input}>{errors.ssn.message}</p>
                                            )}
                                        </td>
                                        <td>
                                            <input {...register("driverLicense", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.driverLicense && "red" }}
                                                  className={errors.driverLicense ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" placeholder="Driver License"/>
                                            {errors.driverLicense && (
                                                <p style={errorStyle.input}>{errors.driverLicense.message}</p>
                                            )}
                                        </td>
                                        <td>
                                            <select {...register("stateIssued", { required: false, maxLength: 200 })}
                                                    style={{ ...styles.input, borderColor: errors.stateIssued && "red" }}
                                                    className="form-control form-control-sm col-md-9 select2">
                                                <option value="-1">Please Select Region</option>
                                                <option value="AL">Alabama</option>
                                                <option value="AK">Alaska</option>
                                                <option value="AZ">Arizona</option>
                                                <option value="AR">Arkansas</option>
                                                <option value="CA">California</option>
                                                <option value="CO">Colorado</option>
                                                <option value="CT">Connecticut</option>
                                                <option value="DE">Delaware</option>
                                                <option value="DC">District Of Columbia</option>
                                                <option value="FL">Florida</option>
                                                <option value="GA">Georgia</option>
                                                <option value="HI">Hawaii</option>
                                                <option value="ID">Idaho</option>
                                                <option value="IL">Illinois</option>
                                                <option value="IN">Indiana</option>
                                                <option value="IA">Iowa</option>
                                                <option value="KS">Kansas</option>
                                                <option value="KY">Kentucky</option>
                                                <option value="LA">Louisiana</option>
                                                <option value="ME">Maine</option>
                                                <option value="MD">Maryland</option>
                                                <option value="MA">Massachusetts</option>
                                                <option value="MI">Michigan</option>
                                                <option value="MN">Minnesota</option>
                                                <option value="MS">Mississippi</option>
                                                <option value="MO">Missouri</option>
                                                <option value="MT">Montana</option>
                                                <option value="NE">Nebraska</option>
                                                <option value="NV">Nevada</option>
                                                <option value="NH">New Hampshire</option>
                                                <option value="NJ">New Jersey</option>
                                                <option value="NM">New Mexico</option>
                                                <option value="NY">New York</option>
                                                <option value="NC">North Carolina</option>
                                                <option value="ND">North Dakota</option>
                                                <option value="OH">Ohio</option>
                                                <option value="OK">Oklahoma</option>
                                                <option value="OR">Oregon</option>
                                                <option value="PA">Pennsylvania</option>
                                                <option value="RI">Rhode Island</option>
                                                <option value="SC">South Carolina</option>
                                                <option value="SD">South Dakota</option>
                                                <option value="TN">Tennessee</option>
                                                <option value="TX">Texas</option>
                                                <option value="UT">Utah</option>
                                                <option value="VT">Vermont</option>
                                                <option value="VA">Virginia</option>
                                                <option value="WA">Washington</option>
                                                <option value="WV">West Virginia</option>
                                                <option value="WI">Wisconsin</option>
                                                <option value="WY">Wyoming</option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Owner Current Address</th>
                                        <th scope="col">City</th>
                                        <th scope="col">Region/Province</th>
                                        <th scope="col">Zip</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input {...register("ownerAddress", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.ownerAddress && "red" }}
                                                  className={errors.ownerAddress ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" placeholder="Owner Current Address"/>
                                            {errors.ownerAddress && (
                                                <p style={errorStyle.input}>{errors.ownerAddress.message}</p>
                                            )}
                                        </td>
                                        <td>
                                            <input {...register("ownerCity", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.ownerCity && "red" }}
                                                  className={errors.ownerCity ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" placeholder="City"/>
                                            {errors.ownerCity && (
                                                <p style={errorStyle.input}>{errors.ownerCity.message}</p>
                                            )}
                                        </td>
                                        <td>
                                            <select {...register("ownerState", { required: "required", maxLength: 200 })}
                                                    style={{ ...styles.input, borderColor: errors.ownerState && "red" }}
                                                    className="form-control form-control-sm col-md-9 select2">
                                                <option value="-1">Please Select Region</option>
                                                <option value="AL">Alabama</option>
                                                <option value="AK">Alaska</option>
                                                <option value="AZ">Arizona</option>
                                                <option value="AR">Arkansas</option>
                                                <option value="CA">California</option>
                                                <option value="CO">Colorado</option>
                                                <option value="CT">Connecticut</option>
                                                <option value="DE">Delaware</option>
                                                <option value="DC">District Of Columbia</option>
                                                <option value="FL">Florida</option>
                                                <option value="GA">Georgia</option>
                                                <option value="HI">Hawaii</option>
                                                <option value="ID">Idaho</option>
                                                <option value="IL">Illinois</option>
                                                <option value="IN">Indiana</option>
                                                <option value="IA">Iowa</option>
                                                <option value="KS">Kansas</option>
                                                <option value="KY">Kentucky</option>
                                                <option value="LA">Louisiana</option>
                                                <option value="ME">Maine</option>
                                                <option value="MD">Maryland</option>
                                                <option value="MA">Massachusetts</option>
                                                <option value="MI">Michigan</option>
                                                <option value="MN">Minnesota</option>
                                                <option value="MS">Mississippi</option>
                                                <option value="MO">Missouri</option>
                                                <option value="MT">Montana</option>
                                                <option value="NE">Nebraska</option>
                                                <option value="NV">Nevada</option>
                                                <option value="NH">New Hampshire</option>
                                                <option value="NJ">New Jersey</option>
                                                <option value="NM">New Mexico</option>
                                                <option value="NY">New York</option>
                                                <option value="NC">North Carolina</option>
                                                <option value="ND">North Dakota</option>
                                                <option value="OH">Ohio</option>
                                                <option value="OK">Oklahoma</option>
                                                <option value="OR">Oregon</option>
                                                <option value="PA">Pennsylvania</option>
                                                <option value="RI">Rhode Island</option>
                                                <option value="SC">South Carolina</option>
                                                <option value="SD">South Dakota</option>
                                                <option value="TN">Tennessee</option>
                                                <option value="TX">Texas</option>
                                                <option value="UT">Utah</option>
                                                <option value="VT">Vermont</option>
                                                <option value="VA">Virginia</option>
                                                <option value="WA">Washington</option>
                                                <option value="WV">West Virginia</option>
                                                <option value="WI">Wisconsin</option>
                                                <option value="WY">Wyoming</option>
                                            </select>
                                            {errors.ownerState && (
                                                <p style={errorStyle.input}>{errors.ownerState.message}</p>
                                            )}
                                        </td>
                                        <td>
                                            <input {...register("ownerZip", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.ownerZip && "red" }}
                                                  className={errors.ownerZip ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" placeholder="Zip"/>
                                            {errors.ownerZip && (
                                                <p style={errorStyle.input}>{errors.ownerZip.message}</p>
                                            )}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th scope="col">Owner Phone #</th>
                                        <th scope="col">Owner Date Of Birth</th>
                                        <th scope="col">Percentage Of Ownership</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input {...register("ownerPhone", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.ownerPhone && "red" }}
                                                  className={errors.ownerPhone ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" />
                                            {errors.ownerPhone && (
                                                <p style={errorStyle.input}>{errors.ownerPhone.message}</p>
                                            )}
                                        </td>
                                        <td>
                                            <input
                                                {...register("ownerDOB", { required: "required", maxLength: 200 })}
                                                style={{ ...styles.input, borderColor: errors.ownerDOB && "red" }}
                                               className={errors.ownerDOB ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="date" />
                                            {errors.ownerDOB && (
                                                <p style={errorStyle.input}>{errors.ownerDOB.message}</p>
                                            )}
                                        </td>
                                        <td>
                                            <input {...register("ownerPercentage", { required: "required", maxLength: 200 })}
                                                   style={{ ...styles.input, borderColor: errors.ownerPercentage && "red" }}
                                                  className={errors.ownerPercentage ? 'form-control form-control-sm col-md-6' : 'form-control form-control-sm col-md-9'} type="text" placeholder="Percentage Of Ownership"/>
                                            {errors.ownerPercentage && (
                                                <p style={errorStyle.input}>{errors.ownerPercentage.message}</p>
                                            )}
                                        </td>
                                    </tr>*/}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {/* START OF NOTES*/}
                        <div className="row">
                            <div className="col-md-12">
                                <h5 className="tbsub-title mt-3 mb-3">Notes</h5>
                                <div className="col-md-12">

                                    <input {...register("paramNoteText", { required: false, maxLength: 200 })}
                                         style={{ ...styles.input, borderColor: errors.paramNoteText && "red",minHeight : "50px" }}
                                         className="form-group row">
                                    </input>


                                </div>
                            </div>
                        </div>
                          <div className="row" style={{marginLeft:"auto"}}>
                              <div className="col-md-3">
                                  <button
                                      type="submit"
                                      className="btn btn-1block btn-primary w-md"
                                      disabled={Boolean(terminalID) && !terminalID.includes("Exception")}
                                  >
                                      Save
                                  </button>
                              </div>
                              <div className="col-md-3">
                                  <button className="btn btn-1block btn-primary w-md"
                                      type="button"
                                      onClick={() => reset()}
                                      value="Reset"
                                  >Reset</button>
                              </div>
                          </div>
                      </form>
                    </div>

                </div>
            </div>

        </div>
            );

}

export default TerminalCreatePage;